import { render, staticRenderFns } from "./inputGcs.vue?vue&type=template&id=28a9fb2e&scoped=true&"
import script from "./inputGcs.vue?vue&type=script&lang=js&"
export * from "./inputGcs.vue?vue&type=script&lang=js&"
import style0 from "./inputGcs.vue?vue&type=style&index=0&id=28a9fb2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a9fb2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCheckbox,VCol,VIcon,VRow,VTextField,VTooltip})
